import React from "react";
import DeviceLogUpload from "../../components/attendance/DeviceLogUpload";

export default function StudentDeviceLogUploadPage() {
  return <DeviceLogUpload subjectType="STUDENT" title="Student Attendance — Device Data Upload" />;
}
